import React from "react";
import { Dropdown } from "semantic-ui-react";
import PropTypes from "prop-types";

export const Sort = ({
  options,
  currentSortBy,
  currentSortOrder,
  onValueChange,
  ariaLabel,
  selectOnNavigation,
}) => {
  const _options = options.map((element) => {
    return {
      key: element.value,
      text: element.text,
      value: element.value,
    };
  });
  const _computeValue = (sortBy, sortOrder) => {
    return sortOrder ? `${sortBy}-${sortOrder}` : sortBy;
  };
  const selected = _computeValue(currentSortBy, currentSortOrder);

  return (
    <Dropdown
      className="sort-by-selector"
      selection
      options={_options}
      value={selected}
      onChange={(e, { value }) => onValueChange(value)}
      aria-label={ariaLabel}
      selectOnNavigation={selectOnNavigation}
    />
  );
};

Sort.propTypes = {
  options: PropTypes.array.isRequired,
  currentSortBy: PropTypes.string,
  currentSortOrder: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  selectOnNavigation: PropTypes.bool,
};
